import React from 'react';
import { Zap, Flame } from 'lucide-react';
import { useHistoryStore } from '@stores/v4/useHistoryStore';

interface EventPillProps {
    label?: string;
    color: string;
    icon?: any;
    value: string | number;
}

const EventPill: React.FC<EventPillProps> = ({ label, color, icon: Icon, value }) => (
    <div style={{ 
        border: `1px solid ${color}44`, 
        padding: '2px 8px', 
        borderRadius: '4px', 
        fontSize: '10px', 
        fontWeight: '900', 
        backgroundColor: `${color}0d`, 
        color: '#fff',
        display: 'flex', 
        alignItems: 'center', 
        gap: '4px',
        textTransform: 'uppercase',
        marginRight: '6px',
        marginBottom: '6px'
    }}>
        {Icon && <Icon size={10} color={color} />}
        {label && <span style={{ color: color, opacity: 0.8 }}>{label}</span>}
        <span>{value}</span>
    </div>
);

interface PerformancePillsProps {
    eventId: string;
    metrics: any;
    themeColor: string;
    isMobility: boolean;
    isAnalyzing: boolean;
}

export const PerformancePills: React.FC<PerformancePillsProps> = ({
    eventId, metrics, themeColor, isMobility, isAnalyzing
}) => {
    return (
        <div style={{ display: 'flex', gap: '6px', marginTop: '10px', flexWrap: 'wrap' }}>
            {metrics.volume > 0 ? (
                <EventPill color={themeColor} value={metrics.volume >= 1000 ? `${(metrics.volume / 1000).toFixed(1)}K` : metrics.volume} icon={Zap} />
            ) : (
                <EventPill color={themeColor} value={isMobility ? 'MOBILITY' : 'RECOVERY'} />
            )}
            
            <div 
                onClick={(e) => { 
                    e.stopPropagation();
                    if (!isAnalyzing) {
                        useHistoryStore.getState().recalculateBurn(eventId);
                    }
                }}
                style={{ cursor: isAnalyzing ? 'wait' : 'pointer' }}
            >
                <EventPill 
                    color="#f29b11" 
                    value={isAnalyzing ? '...' : (metrics.estimated_burn ? `${metrics.estimated_burn} KCAL` : 'ANALYZE')} 
                    icon={Flame}
                />
            </div>

            {metrics.rpe && <EventPill color="#2ecc71" label="INT" value={metrics.rpe} />}
            {metrics.sets && <EventPill color="#888" value={`${metrics.sets} SETS`} />}
        </div>
    );
};
